import { Fieldset, Control, Errors } from "react-redux-form";
import { ContactModel, ContactDetailsModel } from "../models/CommonModels";
import FormItem from '../../components/forms/FormItem';
import * as React from "react";
import { AddressModel } from "../models/CommonModels";
import { renderNewTextField, renderErrorInfoText } from "./FieldCreators";
import nameof from "../../utils/nameof";
import { localizations } from "../../localization/localization";
import * as validators from '../validators/formValidators'

export const AddressFormGroup = () => {
    return <Fieldset model=".address">
        <FormItem>
            <Control required validators={{required: validators.required}} validateOn={["blur", "change"]} model={`.${nameof<AddressModel>("streetAddress")}`} label={localizations.common.streetAddress} component={renderNewTextField} />
            <Errors model={`.${nameof("streetAddress")}`} show={{touched: true, focus: false}} messages={{required: localizations.validation.required}} wrapper={renderErrorInfoText} />
        </FormItem>
        <FormItem>
            <Control required validators= {{isPostalCode: validators.isPostalCode}} validateOn={["blur", "change"]} model={`.${nameof<AddressModel>("postalCode")}`} label={localizations.common.postCode} component={renderNewTextField} />
            <Errors model={`.${nameof("postalCode")}`} show={{touched: true, focus: false}} messages={{isPostalCode: localizations.validation.notAPostalCode}} wrapper={renderErrorInfoText} />
        </FormItem>
        <FormItem>
            <Control required validators={{required: validators.required}} validateOn={["blur", "change"]} model={`.${nameof<AddressModel>("city")}`} label={localizations.common.city} component={renderNewTextField} />
            <Errors model={`.${nameof("city")}`} show={{touched: true, focus: false}} messages={{required: localizations.validation.required}} wrapper={renderErrorInfoText} />
        </FormItem>
    </Fieldset>
}


// WEBPACK FOOTER //
// ./src/common/forms/AddressFormGroup.tsx